﻿import * as React from 'react';
import { Button } from 'react-bootstrap';

export type BookingInformationLabels = {
    bookButton: string;
    travelDistance: string;
    travelTime: string;
    whomToBook: string;
};

type BookingInformationProps = {
    labels: BookingInformationLabels;
    selectedDate: string;
    sessionTime: string;
    originalSessionTime?: string;
    selectedPersonToBook: string;
    travelTime?: string;
    travelDistance?: string;
    onBook: () => void;
    disableBooking?: boolean;
};

export function BookingInformation({
    selectedDate,
    sessionTime,
    originalSessionTime,
    selectedPersonToBook,
    travelTime,
    travelDistance,
    labels,
    onBook,
    disableBooking
}: BookingInformationProps) {
    return (
        <div className="booking-info-container">
            <h1>{selectedDate}</h1>
            <h3>{sessionTime}</h3>
            {originalSessionTime ? <h5>{originalSessionTime}</h5> : null}
            <h4>
                {labels.whomToBook}: {selectedPersonToBook}
            </h4>
            <h4>
                {labels.travelTime}: {travelTime ? ` ${travelTime}` : ' - '}
            </h4>
            <h4>
                {labels.travelDistance}: {travelDistance ? ` ${travelDistance}` : ' - '}
            </h4>
            <p>
                <Button block bsStyle="info" data-testid="booking-book-photographer" disabled={disableBooking} onClick={onBook}>
                    {labels.bookButton}
                </Button>
            </p>
        </div>
    );
}

export default BookingInformation;
